/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_MediumInputs */

const en_onboarding_font_medium = /** @type {(inputs: Onboarding_Font_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const es_onboarding_font_medium = /** @type {(inputs: Onboarding_Font_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediano`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Onboarding_Font_MediumInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_medium = /** @type {((inputs?: Onboarding_Font_MediumInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_MediumInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_medium(inputs)
	return en_onboarding_font_medium(inputs)
});